// extracted by mini-css-extract-plugin
export var cardHeader = "_ej-0";
export var reorderHandle = "_ej-3";
export var titleArea = "_ej-1";
export var titleAreaWithHandle = "_ej-2";